function AjaxListModule(moduleEle) {
  var module = this;
  module.moduleEle = moduleEle;
  module.hideFromQueryString = true;
  module.getModuleValue = function() {
    return {
      PageUrl: instant.settings.currentUrl,
      cultureName: instant.settings.cultureName,
      CurrentContentId: instant.settings.currentContentId,
      FullQueryString: instant.settings.currentQueryString,
      Ajax: true
    };
  }
  module.onServerSuccess = function (eventArgs) {
    //console.log('AjaxListModule.onServerSuccess', eventArgs);
    module.moduleEle.html(eventArgs.response.data.ListHtml);
  }
}

instant.list.settings.moduleClasses['AjaxListModule'] = AjaxListModule;